/**
 * The first question, drawn by index.html before any bundle has loaded, for
 * an ad that skips the door (`?door=plush`). Without it that link shows a
 * blank page until the whole app has arrived — 1.9 s on fast 4G, 3.4 s on
 * slow, inside Facebook's browser (2026-10-14) — where the door link shows
 * its poster in 0.3 s. Same markup as the survey screen (screens/Intro.tsx),
 * so nothing moves when the app takes over; a tap made before then is kept
 * here for the app to act on, as lib/pre-door.ts does for the door.
 */
export interface PreQuiz {
  /** the door the ad named, for the promise line */
  slug: string;
  /** the whole drawn screen, #quiz-pre */
  el: HTMLElement;
  /** the answer tapped before the app was here, if any */
  when: string | null;
  /** "Skip to the exercise" tapped before the app was here */
  skipped: boolean;
  /** performance.now() when it was drawn, and of the first tap */
  drawnAt: number;
  firstTapAt: number | null;
  claimed?: boolean;
}

declare global {
  interface Window { __kindlingPreQuiz?: PreQuiz }
}

/** The drawn question, for the survey screen to take over. */
export function claimPreQuiz(): PreQuiz | null {
  if (typeof window === 'undefined') return null;
  const pre = window.__kindlingPreQuiz;
  if (!pre) return null;
  pre.claimed = true; // StrictMode asks twice: the same one both times
  return pre;
}

/** Once the survey screen is on the page: the drawn one goes. */
export function finishPreQuiz(pre: PreQuiz): void {
  pre.el.remove();
  if (window.__kindlingPreQuiz === pre) window.__kindlingPreQuiz = undefined;
}

/** Take the drawn question away when the app opens on something else. */
export function dropPreQuiz(): void {
  if (typeof window === 'undefined') return;
  const pre = window.__kindlingPreQuiz;
  if (!pre || pre.claimed) return;
  pre.el.remove();
  window.__kindlingPreQuiz = undefined;
}
